import {alphaNum, helpers, maxLength, maxValue, minLength, minValue, required} from "@vuelidate/validators";

import {ValidationRule} from "vuelidate/lib/validators";
import {
    DynamicFieldRegexValidationRule,
    DynamicFieldTextValidationRules,
    DynamicFieldValidationRules
} from '@/global/types/dynamic';
import {ValidationRuleWithoutParams, ValidationRuleWithParams} from '@vuelidate/core';

export type VuelidateValidationRules = Record<string, ValidationRule | ValidationRuleWithoutParams | ValidationRuleWithParams<any, any>>

export function assignDynamicRegexValidatorErrorKey(regex: DynamicFieldRegexValidationRule, index: number): DynamicFieldRegexValidationRule {

    return {
        ...regex,
        error: `regex_${regex.error ?? index}`
    };
}

export function getDynamicFieldVuelidateValidationRules(validation: undefined | DynamicFieldValidationRules, rules: VuelidateValidationRules): VuelidateValidationRules {

    if (undefined !== validation) {

        if (validation.required) {

            rules.required = required;
        }

        if ((validation as DynamicFieldTextValidationRules).minValue) {

            rules.minValue = minValue((validation as DynamicFieldTextValidationRules).minValue as number);
        }

        if ((validation as DynamicFieldTextValidationRules).maxValue) {

            rules.maxValue = maxValue((validation as DynamicFieldTextValidationRules).maxValue as number);
        }

        if ((validation as DynamicFieldTextValidationRules).minLength) {

            rules.minLength = minLength((validation as DynamicFieldTextValidationRules).minLength as number);
        }

        if ((validation as DynamicFieldTextValidationRules).maxLength) {

            rules.maxLength = maxLength((validation as DynamicFieldTextValidationRules).maxLength as number);
        }

        if ((validation as DynamicFieldTextValidationRules).alphaNum) {

            rules.alphaNum = alphaNum;
        }

        if ((validation as DynamicFieldTextValidationRules).regex) {

            const {regex, regex_modifier} = (validation as DynamicFieldTextValidationRules);

            rules.regex = helpers.regex(new RegExp(regex as string, regex_modifier ? regex_modifier as string : undefined));
        }

        if ((validation as DynamicFieldTextValidationRules).regexes) {

            const {regexes} = (validation as DynamicFieldTextValidationRules);

            (regexes as unknown as DynamicFieldRegexValidationRule[])
                .map((regex: DynamicFieldRegexValidationRule, index: number) => assignDynamicRegexValidatorErrorKey(regex, index))
                .forEach(
                    (regex: DynamicFieldRegexValidationRule) => rules[regex.error as string] = helpers.regex(
                        new RegExp(regex.regex, regex.modifier)
                    )
                );
        }
    }

    return rules;
}